/* ---------- Hero: the claim beside the audit running on a real scan ---------- */
.hero {
  /* Same overlap as the home hero: cancel the flow space the sticky header reserves. */
  margin-top: calc(-1 * (var(--header-h) + 2 * var(--header-margin)));
  padding-block: calc(var(--header-h) + 2 * var(--header-margin) + var(--sp-12)) var(--sp-20);
  background: var(--surface-alt);
}
.heroGrid {
  display: grid;
  gap: var(--sp-12);
  align-items: center;
}
.heroText > * {
  max-width: 38rem;
}
.heroTitle {
  /* Room under the breadcrumb, which the dropped eyebrow label used to provide. */
  margin-top: var(--sp-6);
  font-size: clamp(2.4rem, 3.4vw + 1rem, 4.25rem);
  line-height: 1.04;
  letter-spacing: -0.035em;
  text-wrap: balance;
}
.heroLead {
  margin-top: var(--sp-5);
  font-size: var(--fs-lg);
  color: var(--text);
}
.heroActions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: var(--sp-4) var(--sp-8);
  margin-top: var(--sp-8);
}
.heroLink {
  font-weight: 600;
  color: var(--text-strong);
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 0.3em;
}
.heroLink:hover {
  color: var(--accent-text);
}
.heroNote {
  margin: var(--sp-6) 0 0;
  font-size: var(--fs-sm);
  color: var(--text-muted);
}
@media (min-width: 64rem) {
  .heroGrid {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1.1fr);
    gap: var(--sp-16);
  }
}

/* ---------- The signature: ten analyses, each under its own code tile ---------- */
.analyses {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(min(100%, 14rem), 1fr));
  gap: var(--sp-10) var(--sp-8);
  margin: 0;
  padding: 0;
  list-style: none;
}
.analyses li {
  display: grid;
  align-content: start;
  gap: var(--sp-3);
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border-strong);
}
/* The code tile keeps its own size instead of stretching across the column. */
.analyses li > :first-child {
  justify-self: start;
}
.analyses h3 {
  margin: var(--sp-1) 0 0;
  font-size: var(--fs-lg);
}
.analyses p {
  margin: 0;
  font-size: var(--fs-sm);
  color: var(--text);
}
.analysesNote {
  margin: var(--sp-10) 0 0;
  color: var(--text-muted);
}
/* Phones: tile beside the name, the description under both. */
@media (max-width: 47.99rem) {
  .analyses li {
    grid-template-columns: auto 1fr;
    align-items: center;
    column-gap: var(--sp-4);
  }
  .analyses h3 {
    margin: 0;
  }
  .analyses p {
    grid-column: 1 / -1;
  }
}

/* ---------- Inputs: what each kind of project can send ---------- */
.inputs {
  display: grid;
  gap: var(--sp-10) var(--sp-12);
}
.input {
  padding-top: var(--sp-5);
  border-top: 1px solid var(--border-strong);
}
.input h3 {
  margin: 0 0 var(--sp-2);
  font-size: var(--fs-xl);
}
.input p {
  margin: 0 0 var(--sp-5);
  color: var(--text);
}
.formats {
  display: flex;
  flex-wrap: wrap;
  gap: var(--sp-2);
  margin: 0;
  padding: 0;
  list-style: none;
}
.formats li {
  padding: var(--sp-2) var(--sp-4);
  border: 1px solid var(--border-strong);
  border-radius: 999px;
  background: var(--surface-raised);
  color: var(--text-strong);
  font-size: var(--fs-sm);
  font-weight: 600;
}
@media (min-width: 48rem) {
  .inputs {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

/* ---------- Standards and reporting: the points beside the report itself ---------- */
.reporting {
  display: grid;
  gap: var(--sp-12);
  align-items: center;
}
.reportList {
  display: grid;
  gap: var(--sp-6);
  margin: 0;
  padding: 0;
  list-style: none;
}
.reportList li {
  padding-top: var(--sp-4);
  border-top: 1px solid var(--border-strong);
}
.reportList h3 {
  margin: 0 0 var(--sp-2);
  font-size: var(--fs-lg);
}
.reportList p {
  margin: 0;
  color: var(--text);
}
.reportImage {
  border-radius: var(--radius-lg);
  box-shadow:
    0 0 0 1px var(--border),
    var(--shadow-lg);
}
@media (min-width: 64rem) {
  .reporting {
    grid-template-columns: minmax(0, 5fr) minmax(0, 7fr);
    gap: var(--sp-16);
  }
}
